
<que-signature-display [isDisplay]="false" [question]="orginalQuestion"></que-signature-display>
<div class="warp-active-toggle">
    <!--   <p *ngIf="displaySlideToggleType=='groups'" translate>grid.groupsNotActive</p> -->
    <que-toggle [toggleState]="includeDate$()" (toggleEvent)="SetIncludeDate($event)"></que-toggle>
    <p translate>questionBoard.edit.signatureIncludeDate</p>
</div>